var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-title',[_vm._v("\n    Buttons\n    "),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Back")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }